import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Row,
  Button,
  Badge,
} from 'reactstrap';

import {
  Field,
} from 'redux-form';

import TextBox from '../../../../shared/components/form/TextBox';

const ActividadComplementariaTable = ({
  materiaPeriodo,
  fields = {},
  meta: { error, submitFailed },
  onDeleteItemArray,
  onChangeText,
  items,
}) => {
  const isNew = items.some(o => !o.deleted && o.id === 0);
  return (
    <div className="form__form-group-field" style={{ flexDirection: 'column' }}>
      <div>
        <div style={{ display: 'flex', gap: '1rem', flexDirection: 'column' }}>
          {fields.map((objetivo, index) => {
            if (!items[index]) {
              return null;
            }

            return (
              <div
                key={`${objetivo}`}
                id={`${objetivo}`}
                style={{ borderRadius: '10px', padding: '0' }}
                className={(items[index].deleted || (items[index].id > 0 && isNew)) ? 'hidden' : ''}
              >
                <div style={{ borderTop: '0' }}>
                  <Row
                    className="wizard__subform"
                    style={{
                      borderRadius: '10px', borderTop: '0', marginRight: '0', marginLeft: '0',
                    }}
                  >
                    <Col md={12}>
                      <div style={{
                        display: 'flex',
                        gap: '1rem',
                        justifyItems: 'center',
                        justifyContent: 'flex-start',
                        alignItems: 'baseline',
                        padding: '0.4rem',
                      }}
                      >
                        <h3><Badge color="primary">#{index + 1}</Badge></h3>
                        {
                          materiaPeriodo.canEditarPlaneamiento ? (
                            <Button
                              key={`btn-remove-${objetivo}`}
                              onClick={() => onDeleteItemArray({ name: fields.name, index })}
                              size="sm"
                              outline
                              color="danger"
                              style={{ marginBottom: '0px' }}
                              className="font-weight-bold"
                              title={`Eliminar cronograma #${index + 1}`}
                            >
                              <i className="fa fa-trash" aria-hidden="true" />
                            </Button>
                          ) : null
                        }
                      </div>
                    </Col>

                    <Col lg={6} md={6}>
                      <div className="form__form-group">
                        <span className="form__form-group-label required">Descripci&oacute;n de la Actividad</span>
                        <div className="form__form-group-field">
                          <Field
                            name={`${objetivo}.descripcionActividad`}
                            placeholder="Descripci&oacute;n"
                            multiple
                            type="textarea"
                            maxLength="1024"
                            component={TextBox}
                            autoComplete="false"
                            onChange={({ target }) => onChangeText({ target, name: fields.name, index })}
                            disabled={!materiaPeriodo.canEditarPlaneamiento}
                            readOnly={!materiaPeriodo.canEditarPlaneamiento}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} md={6}>
                      <div className="form__form-group">
                        <span className="form__form-group-label required">Beneficiarios</span>
                        <div className="form__form-group-field">
                          <Field
                            name={`${objetivo}.beneficiarios`}
                            placeholder="Beneficiarios"
                            multiple
                            type="textarea"
                            maxLength="1024"
                            component={TextBox}
                            autoComplete="false"
                            onChange={({ target }) => onChangeText({ target, name: fields.name, index })}
                            disabled={!materiaPeriodo.canEditarPlaneamiento}
                            readOnly={!materiaPeriodo.canEditarPlaneamiento}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} md={6}>
                      <div className="form__form-group">
                        <span className="form__form-group-label required">Fechas</span>
                        <div className="form__form-group-field">
                          <Field
                            name={`${objetivo}.fechas`}
                            placeholder="Fechas"
                            multiple
                            type="textarea"
                            maxLength="1024"
                            component={TextBox}
                            autoComplete="false"
                            onChange={({ target }) => onChangeText({ target, name: fields.name, index })}
                            disabled={!materiaPeriodo.canEditarPlaneamiento}
                            readOnly={!materiaPeriodo.canEditarPlaneamiento}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} md={6}>
                      <div className="form__form-group">
                        <span className="form__form-group-label required">Cantidad de Horas</span>
                        <div className="form__form-group-field">
                          <Field
                            name={`${objetivo}.cantidadHoras`}
                            placeholder="Cantidad de Horas"
                            type="number"
                            min={0}
                            max={10000}
                            component={TextBox}
                            autoComplete="false"
                            parse={val => Number(val)}
                            onChange={({ target }) => onChangeText({
                              target: {
                                type: target.type,
                                value: Number(target.value),
                                name: target.name,
                              },
                              name: fields.name,
                              index,
                            })}
                            disabled={!materiaPeriodo.canEditarPlaneamiento}
                            readOnly={!materiaPeriodo.canEditarPlaneamiento}
                          />
                        </div>
                      </div>
                    </Col>

                  </Row>
                </div>
              </div>
            );
          })}
        </div>
        {
          submitFailed && error && (
            <span className="form__form-group-error" style={{ marginBottom: '0.5rem' }}>
              {error}
            </span>
          )
        }
      </div>
    </div>
  );
};

ActividadComplementariaTable.propTypes = {
  onDeleteItemArray: PropTypes.func.isRequired,
  onChangeText: PropTypes.func.isRequired,
  fields: PropTypes.shape({}).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  meta: PropTypes.shape({}),
  materiaPeriodo: PropTypes.shape({}).isRequired,
};

ActividadComplementariaTable.defaultProps = {
  meta: {},
};

export default ActividadComplementariaTable;
